/* ==========================================================================
   Price > Template
   ========================================================================== */

/* Import modules */
const { prepareDataConfig } = require('@bluekiri/alexandria/helpers/dataHelpers');
const PriceFormatter = require('@bluekiri/alexandria/core/PriceFormatter');

const configuration = require('./client/js/config');

/**
 * Price template
 * @param {object} data Object containing the data model for this component.
 * @returns {object} Additional data to have available in the template
 */
module.exports = function Template(data, context) {
    const formatPrice = PriceFormatter(context).format;

    /* Data */
    const { config = {}, value, currency, from, increment, decrement, caption } = data;
    // eslint-disable-next-line dot-notation
    const marketValue = data['market_value'] || false;
    const { dataType } = prepareDataConfig(config.data);

    const { styles = [] } = config;

    const componentStyle = configuration().css.component;
    const style = [componentStyle, ...styles].join(' ').trim('');

    const partials = {
        from: from ? /* html */ `<span class="price-pak__old-price-from">${from}</span>` : '',
        marketValue: marketValue
            ? /* html */ `<span class="price-pak__old">${formatPrice(marketValue, currency)}</span>`
            : '',
        caption: caption ? /* html */ `<span class="price-pak__caption">${caption}</span>` : '',
        pricePrefix:
            increment || decrement
                ? /* html */ `
                    <div class=""> ${increment ? '+' : ''} ${decrement && increment === undefined ? '-' : ''}</div>
                `
                : '',
        price: value
            ? () => /* html */ `
            <div class="price-pak__current">
                ${partials.pricePrefix}${formatPrice(value, currency)}
            </div>
            `
            : '',
        priceTop: () =>
            from || marketValue
                ? /* html */ `
                    <div class="price-pak__top">
                        ${partials.from}
                        ${partials.marketValue}
                    </div>
                `
                : ''
    };

    return /* html */ `
        <div
            class="${style}"
            data-component='${configuration().component}'
            ${dataType ? `data-type='${dataType}'` : ''}
        >
            ${partials.priceTop()}

            ${partials.price()}

            ${partials.caption}

        </div>
    `;
};
